import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { OnmatComponentActivitiesModule } from '@tekman/onmat/component/activities';
import { OnmatUtilsModule } from '@tekman/onmat/utils';
import { SharedComponentGenericModule } from '@tekman/shared/component/generic';
import { SharedComponentModule } from '@tekman/shared/component/shared';
import { SharedUtilsModule, svgIcons } from '@tekman/shared/utils';
import { DropdownItemSelectorComponent } from './dropdown-item-selector/dropdown-item-selector.component';
import { ErrorNotfoundComponent } from './error-404/error-notfound.component';
import { ErrorComponent } from './error/error.component';
import { IdleAlertComponent } from './idle/idle-alert.component';
import { OnmatComponentRoutingModule } from './onmat-component.routing.module';
import { RubricasPanelComponent } from './rubrics-panel/rubricas-panel.component';
import { PanelDirective, SideNavMenuComponent } from './side-nav/side-nav-menu.component';
import { TagsComponent } from './tags/tags.component';
import { TypeformComponent } from './typeform/typeform.component';
import { ExpansionPanelComponent } from './expansion-panel/expansion-panel.component';

@NgModule({
  imports: [
    CommonModule,
    OnmatComponentRoutingModule,
    TranslateModule,
    RouterModule,
    SvgIconsModule.forChild(svgIcons),
    SharedUtilsModule,
    MatSlideToggleModule,
    DragDropModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    SharedComponentModule,
    MatSnackBarModule,
    OnmatUtilsModule,
    OnmatComponentActivitiesModule,
    SharedComponentGenericModule,
  ],
  declarations: [
    ErrorComponent,
    ErrorNotfoundComponent,
    TagsComponent,
    SideNavMenuComponent,
    PanelDirective,
    RubricasPanelComponent,
    DropdownItemSelectorComponent,
    TypeformComponent,
    IdleAlertComponent,
    ExpansionPanelComponent,
  ],
  exports: [
    ErrorComponent,
    ErrorNotfoundComponent,
    TagsComponent,
    SideNavMenuComponent,
    PanelDirective,
    RubricasPanelComponent,
    DropdownItemSelectorComponent,
    TypeformComponent,
    IdleAlertComponent,
    ExpansionPanelComponent,
  ],
})
export class OnmatComponentModule {}
